module.exports = __webpack_public_path__ + "static/img/dnsd_logo.19d5d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dnsd_logo.png
// module id = J/3m
// module chunks = 4